(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
const required = require('@clocklimited/validity-required')

module.exports = function () {
  return schemata(
    { start:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , end:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , artist:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/itinerary/performance-time-schema.js","/components/service/itinerary")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9pdGluZXJhcnkvcGVyZm9ybWFuY2UtdGltZS1zY2hlbWEuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsidmFyIHNjaGVtYXRhID0gcmVxdWlyZSgnc2NoZW1hdGEnKVxuY29uc3QgcmVxdWlyZWQgPSByZXF1aXJlKCdAY2xvY2tsaW1pdGVkL3ZhbGlkaXR5LXJlcXVpcmVkJylcblxubW9kdWxlLmV4cG9ydHMgPSBmdW5jdGlvbiAoKSB7XG4gIHJldHVybiBzY2hlbWF0YShcbiAgICB7IHN0YXJ0OlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgICwgdmFsaWRhdG9yczpcbiAgICAgICAgeyBhbGw6IFsgcmVxdWlyZWQgXVxuICAgICAgICB9XG4gICAgICB9XG4gICAgLCBlbmQ6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgLCB2YWxpZGF0b3JzOlxuICAgICAgICB7IGFsbDogWyByZXF1aXJlZCBdXG4gICAgICAgIH1cbiAgICAgIH1cbiAgICAsIGFydGlzdDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICAsIHZhbGlkYXRvcnM6XG4gICAgICAgIHsgYWxsOiBbIHJlcXVpcmVkIF1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgKVxufVxuIl19